module.exports = __webpack_public_path__ + "static/media/isdoctorplan-general2@2x.2da6c952.png";